import { Box, List, ListItem } from "@chakra-ui/react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { tabMenu } from "../../Constant";

function Tabbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <Box
      w={"200px"}
      marginTop="-5.6rem"
      bg="#FFFFFF"
      boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
      marginLeft={"-1.9rem"}
      h={"calc(100vh - 0px)"}
      position={"fixed"}
    >
      <Box>
        <List spacing={6} marginTop="17rem">
          {tabMenu.map((item) => {
            return (
              <ListItem
                key={item?.id}
                fontSize={"16px"}
                color={pathname === item?.path ? "#fff" : "brand.blue"}
                fontWeight={"500"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                py="0.4rem"
                onClick={() => navigate(item?.path)}
                cursor={"pointer"}
                background={pathname === item?.path ? "#52BBFF" : "transparent"}
                boxShadow={
                  pathname === item?.path
                    ? "rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"
                    : ""
                }
              >
                <Box
                  css={{
                    path: {
                      fill: pathname === item?.path ? "white" : "brand.blue",
                    },
                  }}
                  as="span"
                >
                  {item.icon}
                </Box>
                {item.text}
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Box>
  );
}

export default Tabbar;
